export default {
    bind(el, binding, vnode) {
        if(vnode.isComment) return;

        const auth = vnode.context.$auth;

        var permissions = binding.value.split('|')

        var hasPermission = false;

        if (permissions != undefined) {
            permissions.forEach(permission => {
                if (auth.hasPermission(permission)) {
                    hasPermission = true;
                    return;
                }
            });
        }

        if (hasPermission) return;

        // replace HTMLElement with comment node
        const comment = document.createComment(' ');
        Object.defineProperty(comment, 'setAttribute', {
            value: () => undefined,
        });
        vnode.elm = comment;
        vnode.text = ' ';
        vnode.context = undefined;
        vnode.data.directives = undefined;

        if (vnode.componentInstance) {
            vnode.componentInstance.$el = comment;
        }

        if (el.parentNode) {
            el.parentNode.replaceChild(comment, el);
        }
    },
    inserted: function () {},
    update: function () {},
    componentUpdated: function () {},
    unbind: function () {}
}